module.exports = __webpack_public_path__ + "static/media/2-focus.925b6ecc.svg";